let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gAZMZ")).then(() => parcelRequire('8C9Mf'));